<template>
  <v-container>
      <v-layout row v-if="error">
        <v-flex xs12 sm6 offset-sm3>
            <alert @dismissed="onDismissed" :text="error.message"></alert>
        </v-flex>
      </v-layout>
      <v-layout row>
          <v-flex xs12 sm6 offset-sm3>
              <v-card>
                  <v-card-text>
                      <v-container>
                          <form>
                              <v-layout row>
                                  <v-flex xs12>
                                      <v-text-field 
                                        name="email"
                                        label="Mail"
                                        id="email"
                                        v-model="email"
                                        type="email"
                                        required>
                                      </v-text-field>
                                  </v-flex>
                              </v-layout>
                              <v-layout row>
                                  <v-flex xs12>
                                      <v-text-field 
                                        name="password"
                                        label="password"
                                        id="password"
                                        v-model="password"
                                        :append-icon="e2 ? 'visibility' : 'visibility_off'"
                                        :append-icon-cb="() => (e2 = !e2)"
                                        :type="e2 ? 'password' : 'text'"
                                        required>
                                      </v-text-field>
                                  </v-flex>
                              </v-layout>
                              <v-layout>
                                  <v-flex xs12>
                                      <v-btn @click.prevent="onSignIn" type="submit">Sign In</v-btn>
                                  </v-flex>
                              </v-layout>
                          </form>
                      </v-container>
                  </v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      e1: false,
      e2: true,
      password: '',
      email: ''
    }
  },
  computed: {
    user: function () {
      return this.$store.getters.user
    },
    error: function () {
      return this.$store.getters.error
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    onSignIn: function () {
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onDismissed: function () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?6adc6579